import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TablePagination,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";

import hipladeTemplate from "../../common/template";
import CourseService from "../../services/CourseService";
import { useModal } from "../../common/hooks/useModal";
import { toast } from "react-toastify";

export default function List() {
  const { handleOpenModal } = useModal();

  const [courses, setCourses] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);

  const loadCourses = (p = 1, paginate = 10) => {
    CourseService.getAll(p, paginate)
      .then((response: any) => {
        const data = response?.data;
        if (data) {
          setCourses(data?.data || data || []);
          setTotal(data?.total || (data?.data ? data.data.length : 0));
        }
      })
      .catch((e: any) => {
        toast(e?.response?.data?.Error || "Erro ao carregar cursos", { type: "error" });
      });
  };

  useEffect(() => {
    loadCourses(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleChangePage = (_: unknown, newPage: number) => {
    // TablePagination uses zero-based pages
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleOpenCreate = () => {
    handleOpenModal({
      displayName: "CourseModal",
      data: {
        loadCourses: (p: number, pag: number) => loadCourses(p, pag),
        onCreated: (newId: any) => {
          // optionally select or navigate to created item
          loadCourses(1, rowsPerPage);
          toast("Curso criado com sucesso", { type: "success" });
        },
      },
    });
  };

  const handleOpenEdit = (id: any) => {
    handleOpenModal({
      displayName: "CourseModal",
      data: {
        idCourse: id,
        loadCourses: (p: number, pag: number) => loadCourses(p, pag)
      },
    });
  };

  const handleDelete = (id: any) => {
    if (!window.confirm("Deseja excluir este curso?")) return;
    CourseService.remove(id)
      .then((res: any) => {
        toast(res?.data?.Msg || "Excluído com sucesso", { type: "success" });
        loadCourses(page, rowsPerPage);
      })
      .catch((e: any) => {
        toast(e?.response?.data?.Error || "Erro ao excluir", { type: "error" });
      });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Gestão de Cursos</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpenCreate}>
          Novo Curso
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {courses && courses.length > 0 ? (
              courses.map((row: any) => (
                <TableRow key={row.id} hover>
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="right">
                    <IconButton size="small" onClick={() => handleOpenEdit(row.id)}>
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleOpenModal({ displayName: "CourseDetailsModal", data: { idCourse: row.id } })}>
                      <SettingsIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" onClick={() => handleDelete(row.id)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2}>Nenhum curso encontrado</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={total}
          page={page - 1}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </TableContainer>
    </Box>
  );
}
